<template>
  <section class="tw-bg-black tw-mb-14 md:tw-mb-16 lg:tw-mb-20 xl:tw-mb-36">
    <section>
      <CommonHeader is-light show-kyc />
      <section class="tw-container tw-mx-auto tw-flex tw-flex-col tw-pt-14 md:tw-pt-20">
        <section class="tw-max-w-[960px] tw-mx-auto tw-text-center tw-px-0 tw-text-white">
          <div class="tw-text-[40px] md:tw-text-5xl lg:tw-text-6xl !tw-leading-snug tw-font-semibold" v-html="$t('Global Payment Infrastructure for the future')">
          </div>
          <div class="bg tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-center tw-py-16 tw-gap-y-16 tw-mt-10 lg:tw-mt-20">
            <p class="tw-text-left tw-text-base sm:tw-text-lg tw-basis-5/12 tw-order-last md:tw-order-none"
              >{{ $t("We envision a future where global finance is open to all, making financial markets accessible to everyone") }}</p
            >
            <div class="tw-basis-5/12 tw-flex tw-justify-center tw-items-center">
              <SvgoCommonLogo class="tw-rotate-90 tw-w-40 lg:tw-w-52" />
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="tw-container tw-mx-auto tw-flex tw-flex-col tw-gap-24 md:tw-gap-20 lg:tw-gap-40 tw-py-14 md:tw-py-20">
      <section class="tw-bg-secondary tw-rounded-2xl md:tw-rounded-3xl tw-px-4 tw-py-14 sm:tw-py-16 md:tw-py-18 lg:tw-py-22">
        <div class="tw-max-w-[1024px] tw-mx-auto tw-text-center tw-px-0">
          <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
            <div class="tw-basis-full md:tw-basis-1/2 tw-text-left tw-flex tw-flex-col tw-justify-center tw-items-start">
              <h3 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black !tw-leading-normal tw-text-left">
                {{ $t("Connecting the World!") }}
              </h3>
              <h3 class="tw-text-base md:tw-text-lg tw-mt-5 !tw-leading-relaxed" v-html="$t('Our infrastructure and services empower millions of users')">
              </h3>
            </div>
            <div class="tw-basis-full md:tw-basis-1/2 tw-flex">
              <div class="tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-gap-3 md:tw-gap-4 lg:tw-gap-5 tw-flex-1">
                <div
                  v-for="(item, index) in gridData"
                  :key="index"
                  class="tw-min-h-[90px] tw-bg-primary tw-rounded-lg lg:tw-rounded-xl tw-p-3 tw-flex-1 tw-flex tw-items-center tw-justify-between"
                >
                  <div class="tw-flex tw-flex-col tw-w-full tw-text-white">
                    <h3 class="tw-font-bold lg:tw-font-black tw-text-2xl sm:tw-text-3xl md:tw-text-4xl lg:tw-text-5xl">{{ item.title }}</h3>
                    <div class="tw-uppercase tw-text-xs sm:tw-text-sm md:tw-text-base tw-font-black">
                      {{ item.subTitle }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="tw-max-w-5xl tw-mx-auto tw-px-0 tw-text-white">
        <h6 class="tw-text-primary tw-mb-4 lg:tw-mb-2 tw-leading-tight tw-text-xl md:tw-text-2xl tw-uppercase lg:tw-text-center"
          >{{ $t('OUR MISSION') }}</h6
        >
        <h2 class="tw-font-bold tw-leading-snug lg:tw-leading-tight tw-text-[32px] lg:tw-text-[54px] lg:tw-text-center"
          >{{ $t('Build a Borderless Financial Infrastructure') }}</h2
        >
        <ul class="tw-my-10 lg:tw-my-24 tw-text-lg tw-font-medium tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between tw-gap-y-4">
          <li class="tw-flex tw-gap-4 tw-items-center">
            <label class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-text-white">1</label>
            {{ $t('Global crypto liquidity') }}
          </li>
          <li class="tw-flex tw-gap-4 tw-items-center">
            <label class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-text-white">2</label>
            {{ $t('Global banking network') }}
          </li>
          <li class="tw-flex tw-gap-4 tw-items-center">
            <label class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-text-white">3</label>
            {{ $t('Global payment infrastructure') }}
          </li>
        </ul>
        <section class="tw-flex tw-flex-col md:tw-flex-row tw-gap-3 lg:tw-gap-10 xl:tw-hidden">
          <div class="tw-flex tw-justify-center tw-items-center">
            <div class="tw-relative tw-text-[#ededf4] tw-font-bold tw-text-base">
              <NuxtImg src="/res/img/about/world-eps-mobile.png" />
              <div class="tw-absolute tw-h-[8%] tw-top-[32%] tw-left-[14%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />1
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[22%] tw-left-[45%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />2
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[65%] tw-left-[35%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />3
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[54%] tw-left-[75%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />4
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[43%] tw-left-[78%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />5
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[34%] tw-left-[82%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />6
              </div>
              <div class="tw-absolute tw-h-[8%] tw-top-[75%] tw-left-[52.5%] tw-z-10 tw-flex tw-gap-1 tw-items-center">
                <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />7
              </div>
            </div>
          </div>
          <div class="tw-grid tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-y-4 tw-gap-x-2">
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">1</h2>
              <p class="tw-text-sm tw-leading-tight">Legend Trading USA (Global HQ)</p>
              <p class="tw-text-[10px] tw-text-primary">Pleasanton, USA</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">2</h2> <p class="tw-text-sm tw-leading-tight">Legend Trading EU</p>
              <p class="tw-text-[10px] tw-text-primary">Dublin, Ireland</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">3</h2> <p class="tw-text-sm tw-leading-tight">Legend Trading LATAM</p>
              <p class="tw-text-[10px] tw-text-primary">São Paulo, Brazil</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">4</h2> <p class="tw-text-sm tw-leading-tight">Legend Trading APAC </p
              ><p class="tw-text-[10px] tw-text-primary">Singapore </p><p class="tw-text-[10px] tw-text-primary">Kuala Lumpur, Malaysia</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">5</h2>
              <p class="tw-text-sm tw-leading-tight">Legend Trading <br />Hong Kong</p>
              <p class="tw-text-[10px] tw-text-primary">Hong Kong</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">6</h2>
              <p class="tw-text-sm tw-leading-tight">Legend Trading <br />South Korea</p>
              <p class="tw-text-[10px] tw-text-primary">Seoul, South Korea</p>
            </div>
            <div>
              <h2 class="tw-text-2xl tw-font-bold tw-leading-none">7</h2> <p class="tw-text-sm tw-leading-tight">Legend Trading Africa</p>
              <p class="tw-text-[10px] tw-text-primary">Johannesburg, South Africa</p>
            </div>
          </div>
        </section>
        <section class="tw-relative tw-hidden xl:tw-flex tw-text-[#ededf4]">
          <NuxtImg src="/res/img/about/world-eps-mobile.png" class="tw-w-full" />
          <div class="tw-absolute tw-h-[8%] tw-top-[32%] tw-left-[14%] tw-z-10 tw-flex tw-gap-3 tw-items-start">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading USA</p>
              <p class="tw-font-bold">(Global HQ)</p>
              <p class="tw-text-xs tw-scale-95">Pleasanton, USA</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[23%] tw-left-[45%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading EU</p>
              <p class="tw-text-xs tw-scale-95">Dublin, Ireland</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[65%] tw-left-[35%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading LATAM</p>
              <p class="tw-text-xs tw-scale-95">São Paulo, Brazil</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[54%] tw-left-[75%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading APAC </p>
              <p class="tw-text-xs tw-scale-95">Singapore</p>
              <p class="tw-text-xs tw-scale-95">Kuala Lumpur, Malaysia</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[43%] tw-left-[78%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading Hong Kong</p>
              <p class="tw-text-xs tw-scale-95">Hong Kong</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[34%] tw-left-[81.5%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading South Korea</p>
              <p class="tw-text-xs tw-scale-95">Seoul, South Korea</p>
            </div>
          </div>
          <div class="tw-absolute tw-h-[8%] tw-top-[75%] tw-left-[52.5%] tw-z-10 tw-flex tw-gap-3 tw-items-center">
            <NuxtImg src="/res/img/about/shape.png" class="tw-h-full" />
            <div class="tw-text-sm">
              <p class="tw-font-bold tw-text-nowrap">Legend Trading Africa</p>
              <p class="tw-text-xs tw-scale-95 tw-text-nowrap">Johannesburg, South Africa</p>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
  <section class="tw-bg-white tw-mb-14 md:tw-mb-16 lg:tw-mb-20">
    <div class="tw-container tw-mx-auto">
      <div class="tw-max-w-[960px] tw-mx-auto tw-px-0 tw-mb-20 lg:tw-mb-36">
        <h2 class="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-black lg:tw-text-center">{{ $t('Payments in the future…') }}</h2>
        <div class="tw-flex tw-flex-col">
          <p class="tw-mt-6 lg:tw-text-center"
            >{{ $t('The Internet Money will help us build a borderless financial system eventually.') }}</p
          >
          <div
            class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-2 tw-justify-center tw-items-center tw-text-2xl tw-font-medium md:tw-font-bold tw-leading-tight tw-mt-12 lg:tw-mt-20"
          >
            <h6>{{ $t('Internet') }}</h6>
            <span class="tw-font-bold tw-text-primary md:tw-text-black">+</span>
            <h6>{{ $t('Blockchain') }}</h6>
            <span class="tw-font-bold tw-text-primary md:tw-text-black">+</span>
            <h6>{{ $t('Stablecoins') }}</h6>
            <span class="tw-font-bold tw-text-primary md:tw-text-black">=</span>
            <h6 class="tw-font-bold tw-text-center">{{ $t('FAST Cross-border Payments') }}</h6>
          </div>
          <div class="tw-flex tw-justify-center tw-items-center tw-mt-12 md:tw-mt-6">
            <NuxtImg src="/res/img/about/img.png" class="tw-max-w-80 md:tw-hidden" />
            <NuxtImg src="/res/img/about/img2.png" class="tw-w-full tw-hidden md:tw-block" />
          </div>
        </div>
      </div>
      <div class="tw-max-w-[960px] tw-mx-auto tw-text-center tw-px-0">
        <h2 class="tw-text-3xl md:tw-text-4xl tw-font-black tw-leading-none">{{ $t('our-partners') }}</h2>
        <!-- <p class="tw-text-base md:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
          {{
            $t(
              'legend-trading-has-partnered-and-collaborated-with-worlds-leading-brands-in-crypto-and-traditional-financial-firms-included-but-not-limited-to',
            )
          }}
        </p> -->
        <div class="tw-mt-14 lg:tw-mt-12 xl:tw-mt-24">
          <PartnerShipsHome />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n()
  const gridData = computed(() => [
    { title: '900+', subTitle: t('institutions') },
    { title: t('millions'), subTitle: t('retail-investors') },
    { title: '40+', subTitle: t('top-partners') },
    { title: '150+', subTitle: t('countries') },
  ])
  definePageMeta({
    middleware: ['sosovalue', 'ip2location'],
  })
</script>
<style scoped lang="scss">
  .bg {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      top: 80px;
      left: 50%;
      transform: translate(-50%, -50%);
      background: url('/res/img/shadowbg/chartline-gold.svg') repeat 15% 50%;
      background-size: cover;
      width: 100%;
      height: 200px;
    }
    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      top: 230px;
      left: 50%;
      transform: translate(-50%, -50%);
      background: url('/res/img/shadowbg/chartline-gold.svg') repeat 41% 50%;
      background-size: cover;
      width: 100%;
      height: 200px;
    }
  }

  .bg2 {
    background: url('/res/img/about/bg.png') repeat;
    background-size: cover;
  }

  .text-10 {
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    transform: scale(0.8);
  }
</style>
